<template>
    <div class="site-panel v-flex" v-if="site">
        <c-dms-treeview-unit
            :unit = "site"
            :height = "810"
        />
    </div>
</template>

<script>

import CDmsTreeviewUnit from "@/modules/dms/treeview/components/CDmsTreeviewUnit.vue";

export default {
    name: "TSiteDocuments",

    components: {
        CDmsTreeviewUnit
    },

    props: {
        site: {

        }
    }
}
</script>

<style scoped>

</style>